<template>
  <div class="inline-flex items-center border-2 border-border rounded-md overflow-hidden">
    <button
      v-for="code in localeStore.supportedLocales"
      :key="code"
      class="px-3 py-1.5 text-sm font-medium transition-colors"
      :class="localeStore.locale === code ? activeClass : inactiveClass"
      :aria-pressed="localeStore.locale === code"
      @click="localeStore.switchLocale(code)"
    >
      {{ $t(`lang.${code}`) }}
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useLocaleStore } from '../stores/locale.js';

const localeStore = useLocaleStore();

const activeClass = computed(() => 'bg-text-primary text-bg');
const inactiveClass = computed(() => 'bg-bg-white text-text-secondary hover:text-text-primary hover:bg-brutal-cream');
</script>
